/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
import {lazy, Suspense} from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import ProtectedLayout from './components/templates/protected-layout.component';
import Loader from './components/atoms/loader.component';

const DashboardPage = lazy(() => import('./components/pages/dashboard.page'));
const LicensesPage = lazy(() => import('./components/pages/licenses.page'));

function App() {
  return (
    <>
      <Suspense fallback={<Loader fullPage />}>
        <Routes>
          <Route element={<ProtectedLayout />}>
            <Route path="/" element={<DashboardPage />} />
            <Route path="/licencias" element={<LicensesPage />} />
          </Route>
          <Route path="/*" element={<Navigate to="/" replace />}/>
        </Routes>
      </Suspense>
    </>
  );
}

export default App;
